<div class="post-card__image">
    <a routerLink="/blog/latest-news/{{post.slug}}">
        <img [src]="post.image" alt=""
        style="height: 200px"
        >
    </a>
</div>
<div class="post-card__content">
    <!-- <div class="post-card__category">
        <a *ngFor="let category of post.categories" href="">{{ category }}</a>
    </div> -->
    <div class="post-card__title">
        <h2><a routerLink="/blog/latest-news/{{post.slug}}">{{ post.title }}</a></h2>
    </div>
    <div class="post-card__excerpt">
        <div class="typography">
            <p [innerHtml]="post.small_description"></p>
        </div>
    </div>
    <div class="post-card__date">
        By <a routerLink="/shop/products/{{post.get_slug}}">{{post.get_name }}</a> on {{ post.date }}
    </div>

    <div class="post-card__more">
        <a routerLink="/blog/latest-news/{{post.slug}}" class="btn btn-secondary btn-sm">Read more</a>
    </div>
</div>
